import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../store/store";
import NoClientDashboardPage from "./NoClientDashboardPage";
import ClientDashboardPage from "./ClientDashboardPage";
import { useNavigate } from "react-router-dom";
import { scrollPageToTop } from "../store/system.store";

const Dashboard = () => {
  const user = useSelector((state: StoreState) => state.user.loggedInUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onProductSelect = (href: string) => {
    navigate(`product${href}`);
    dispatch(scrollPageToTop());
  };

  return user?.isClient ? (
    <ClientDashboardPage onProductSelect={onProductSelect} />
  ) : (
    <NoClientDashboardPage onProductSelect={onProductSelect} />
  );
};

export default Dashboard;
